import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  title: {
    margin: 'auto 5px',
    color: '#248',
    fontWeight: '500',
    fontSize: '1.4rem'
  }
});
